export default __webpack_public_path__ + "static/rustDev-357a646247668eca29b1ea3b9eedf58f.jpg";